import { ArService } from 'src/app/services/ar.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-airlines',
  templateUrl: './airlines.component.html',
  styleUrls: ['./airlines.component.scss']
})
export class AirlinesComponent implements OnInit {

  filteredAirlines;
  searchText;
  allairlineServices;
  activePage;

  constructor(private router:Router,
    private spinner:NgxSpinnerService,
    private arService:ArService) {
      this.getData();
     }

  ngOnInit() {
    this.getAllAirlines();
  }

  getAllAirlines(){
    this.spinner.show();
    this.arService.getAllAirlineServices().subscribe(res => {
      this.allairlineServices = res['result']
      this.spinner.hide();
    })
  }

  addAirlineService(){
    this.router.navigateByUrl('home/add-airlines')
  }

  getData(){
    this.searchText = '';
    this.getAllAirlines();
  }

  
}
